import { render, staticRenderFns } from "./FeaturedCarousel.vue?vue&type=template&id=ce96ed80&scoped=true"
import script from "./FeaturedCarousel.vue?vue&type=script&lang=js"
export * from "./FeaturedCarousel.vue?vue&type=script&lang=js"
import style0 from "./FeaturedCarousel.vue?vue&type=style&index=0&id=ce96ed80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce96ed80",
  null
  
)

export default component.exports